import React, { Component } from "react";

//style
import { Container } from "./Rodape.style";
import { Link } from "react-router-dom";

import $ from "jquery";

import FAQ from "../../../src/assets/pdfs/FAQ.pdf";
import TERMOS from "../../../src/assets/pdfs/TERMOS.pdf";
import "./Rodape.css";
class Rodape extends Component {
  constructor(props) {
    super(props);
    let baseUriHome = window._env_.API_HOME_ISTOE;
    const date = new Date().getFullYear();
    fetch(baseUriHome).then(async (response) => {
      let resp = await response.json();
      let fixFooter = resp.footer;
      fixFooter = fixFooter.replace("2021", date);
      this.refs.htmlRef.innerHTML = fixFooter;
      $("img", this.refs.htmlRef).each(function () {
        let $t = $(this);
        $t.attr("src", "https://istoe.com.br/wp-content/themes/project_theme/assets/img/logo-3.png?x27602");
      });
      $("a", this.refs.htmlRef).each(function () {
        let $a = $(this);
        $a.attr("href", TERMOS).attr("target", "_blank");
      });
    });
  }
  render() {
    return (
      // footerbrj
      <div contentEditable="false" ref="htmlRef"></div>
      // !footerbrj
    );
  }
}
export default Rodape;
